import { BrowserTracing, init } from '@sentry/react'

import { CONFIG } from 'config'

export function initSentry() {
  if (['localhost', '127.0.0.1'].includes(window.location.hostname)) return
  if (!CONFIG.SENTRY_DSN) return
  init({
    dsn: CONFIG.SENTRY_DSN,
    integrations: [new BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    beforeSend(event, hint: any) {
      const oriExc = hint.originalException
      // console.log(JSON.stringify(hint, null, 4))
      // console.log(JSON.stringify(event, null, 4))
      if (oriExc?.name === 'ApiError' && event.exception?.values) {
        const errorMessage = `${oriExc?.status}: ${oriExc?.request?.method} ${oriExc?.request.url}  `
        event.exception.values[0].value = errorMessage

        event.extra = {
          ...event.extra,
          request: oriExc.request,
          responseBody: oriExc.body,
        }
      }
      return event
    },
    beforeBreadcrumb(breadcrumb, hint) {
      // Don't send fetch requests to Sentry
      if (breadcrumb.category === 'ui.click' && hint) {
        // remove classess from the breadcrumb
        breadcrumb.message = breadcrumb.message?.replace(/\.[^[\]]+/g, '')
        const target = hint.event.target
        if (target.ariaLabel) {
          breadcrumb.message += ` ${target.ariaLabel}`
        }
      }
      return breadcrumb
    },
  })
}
